/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import URLSearchParams from "url-search-params";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";

import AppLocale from "lngProvider";
import MainApp from "./MainApp";

import {
  onLayoutTypeChange,
  onNavStyleChange,
  setThemeType,
} from "appRedux/actions/Setting";

import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
} from "@/constants/ThemeSetting";
import secureLocalStorage from "react-secure-storage";
import { setAuthData } from "@/appRedux/actions";
import ForgotPassword from "../ForgotPassword";
import SendOtp from "../SendOtp";
import OptSubmit from "../OptSubmit";
import ResetPassword from "../ResetPassword";
// import SignIn from "../Signv2";
import SignIn from "../SignInV3";
import Registration from "@/containers/Registration";
import RegistrationSuccess from "@/containers/Registration/rigistrationsuccess";
import DecisionForm from "../DecisonForm/DecisionForm";

const RestrictedRoute = ({
  component: Component,
  location,
  authUser,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      authUser ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/signin",
            state: { from: location },
          }}
        />
      )
    }
  />
);

const setLayoutType = (layoutType) => {
  if (layoutType === LAYOUT_TYPE_FULL) {
    document.body.classList.remove("boxed-layout");
    document.body.classList.remove("framed-layout");
    document.body.classList.add("full-layout");
  } else if (layoutType === LAYOUT_TYPE_BOXED) {
    document.body.classList.remove("full-layout");
    document.body.classList.remove("framed-layout");
    document.body.classList.add("boxed-layout");
  } else if (layoutType === LAYOUT_TYPE_FRAMED) {
    document.body.classList.remove("boxed-layout");
    document.body.classList.remove("full-layout");
    document.body.classList.add("framed-layout");
  }
};

const setNavStyle = (navStyle) => {
  if (
    navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
    navStyle === NAV_STYLE_DARK_HORIZONTAL ||
    navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
    navStyle === NAV_STYLE_ABOVE_HEADER ||
    navStyle === NAV_STYLE_BELOW_HEADER
  ) {
    document.body.classList.add("full-scroll");
    document.body.classList.add("horizontal-layout");
  } else {
    document.body.classList.remove("full-scroll");
    document.body.classList.remove("horizontal-layout");
  }
};

let styleSheetLink = document.createElement("link");
styleSheetLink.type = "text/css";
styleSheetLink.rel = "stylesheet";
document.body.appendChild(styleSheetLink);

const App = () => {
  const locale = useSelector(({ settings }) => settings.locale);
  const navStyle = useSelector(({ settings }) => settings.navStyle);
  const layoutType = useSelector(({ settings }) => settings.layoutType);
  const isDirectionRTL = useSelector(({ settings }) => settings.isDirectionRTL);

  const dispatch = useDispatch();

  const location = useLocation();
  const match = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    if (isDirectionRTL) {
      document.documentElement.classList.add("rtl");
      document.documentElement.setAttribute("data-direction", "rtl");
    } else {
      document.documentElement.classList.remove("rtl");
      document.documentElement.setAttribute("data-direction", "ltr");
    }
  }, [isDirectionRTL]);

  useEffect(() => {
    if (locale) document.documentElement.lang = locale.locale;
  }, [locale]);

  useEffect(() => {
    // if (initURL === '') {
    //   dispatch(setInitUrl(location.pathname));
    // }
    const params = new URLSearchParams(location.search);

    if (params.has("theme")) {
      dispatch(setThemeType(params.get("theme")));
    }
    if (params.has("nav-style")) {
      dispatch(onNavStyleChange(params.get("nav-style")));
    }
    if (params.has("layout-type")) {
      dispatch(onLayoutTypeChange(params.get("layout-type")));
    }
  }, [location.search, dispatch, location.pathname]);

  useEffect(() => {
    setLayoutType(layoutType);
    setNavStyle(navStyle);
  }, [layoutType, navStyle]);

  useEffect(() => {
    const endpoint = location.pathname;

    if (endpoint === ("/registration") || endpoint === "/registrationsuccess") {

    } else if (endpoint === "/form/decision-form") {
      history.push("/form/decision-form");
    } else {
      if (
        secureLocalStorage.getItem("token") &&
        secureLocalStorage.getItem("userData") &&
        secureLocalStorage.getItem("permissions")
      ) {
        dispatch(
          setAuthData({
            user: secureLocalStorage.getItem("userData"),
            token: secureLocalStorage.getItem("token"),
            permissions: secureLocalStorage.getItem("permissions"),
          })
        );
        if (window.location.pathname === "/") {
          history.push("/dashboard");
        }
        history.push(window.location.pathname);
      } else {
        history.push("/signin");
      }
    }
  }, []);

  console.log("window.location.pathname", window.location.pathname)

  const currentAppLocale = AppLocale[locale.locale];

  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={isDirectionRTL ? "rtl" : "ltr"}
    >
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Switch>
          <Route exact path="/form/decision-form" component={DecisionForm} />
          <Route exact path="/registration" component={Registration} />
          <Route exact path="/registrationsuccess" component={RegistrationSuccess} />
          <Route exact path="/signin" component={SignIn} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/send-otp" component={SendOtp} />
          <Route exact path="/otp-submit" component={OptSubmit} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <RestrictedRoute
            authUser={secureLocalStorage.getItem("userData")}
            path={`${match.url}`}
            location={location}
            component={MainApp}
          />
        </Switch>
      </IntlProvider>
    </ConfigProvider>
  );
};

export default memo(App);
